import HeaderNone from './../../components/component/header/header_none.jsx';

import PolicyComponent from './../../components/component/policy_components/policy.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function Policy() {
    return (
            <main>
                <HeaderNone />
                <PolicyComponent />

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default Policy;

